import { Theme } from 'api/models/Common/JyrneyEnums';
import sunways from 'app/styles/themes/sunways';
import taketwo from 'app/styles/themes/taketwo';
import tysers from 'app/styles/themes/tysers';
import { useSelector } from 'react-redux';
import {
    advantage,
    belz,
    easthouse,
    jyrney,
    onwrd,
    pendragon,
    reedMackay,
    runyourfleet,
    scs,
    takeme,
    veezu,
    veezuBBC,
} from '../styles/themes';

export function resolveTheme(
  themeName: string | null | undefined,
  host: string,
) {
  // Dev-only override via localStorage (see ThemeSwitcher), gated to localhost
  // by the switcher itself.
  const override =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('__themeOverride')
      : null
  const effectiveTheme = override || themeName

  if (effectiveTheme) {
    switch (effectiveTheme) {
      case Theme.EASTHOUSE:
        return easthouse
      case Theme.ADVANTAGE:
        return advantage
      case Theme.RUNYOURFLEET:
        return runyourfleet
      case Theme.ONWRD:
        return onwrd
      case Theme.PENDRAGON:
        return pendragon
      case Theme.SCS:
        return scs
      case Theme.TAKEME:
        return takeme
      case Theme.TAKETWO:
        return taketwo
      case Theme.JYRNEY:
        return jyrney
      case Theme.REEDANDMACKAY:
        return reedMackay
      case Theme.SUNWAYS:
        return sunways
      case Theme.TYSERS:
        return tysers
      case Theme.VEEZU:
        return veezu
      case Theme.BELZ:
        return belz
      case Theme.VEEZU_BBC:
        return veezuBBC
    }
  }

  if (host.startsWith('onwrd.jyrney.com')) {
    return onwrd
  } else if (host.startsWith('pendragon.jyrney.com')) {
    return pendragon
  } else if (host.startsWith('scs.jyrney.com')) {
    return scs
  } else if (host.startsWith('application.com')) {
    return scs
  } else if (host.includes('reedmackay')) {
    return reedMackay
  } else if (host.includes('tysers')) {
    return tysers
  } else if (host.includes('veezustaging')) {
    return veezuBBC
  } else if (host.includes('veezu')) {
    return veezu
  } else if (host.includes('takeme')) {
    return takeme
  } else if (host.includes('belz')) {
    return belz
  }

  return jyrney
}

export default function useCurrentTheme(host: string) {
  const activeTheme = useSelector(
    (state: any) => state.clients?.client?.applicationTheme?.name,
  )
  return resolveTheme(activeTheme, host)
}
